import 'css-chunk:src/index/components/tabmenu/tabmenu.module.scss';export default {
  "tablet": "tablet__rTFV0",
  "sp": "sp__-vNii",
  "pc": "pc__NEO1r",
  "pcTablet": "pcTablet__ms4TF",
  "section": "section__Thwcc",
  "relative": "relative__yi5sy",
  "row": "row__hSDJf",
  "middle": "middle__C7psx",
  "formLabel": "formLabel__c-9W2",
  "formLabel2": "formLabel2__xfO28",
  "formLabelIssue": "formLabelIssue__Xxo1p",
  "root": "root__Tncv5",
  "logos": "logos__9MFeZ",
  "logo": "logo__YJXA9",
  "menu_bg": "menu_bg__9yqLf",
  "menu_button": "menu_button__GKTYl",
  "tab": "tab__PkO1-",
  "child": "child__mgeG-",
  "issueButton": "issueButton__NWlGA",
  "time": "time__62OMY",
  "nameArea": "nameArea__15Oax"
};